import "./app";
import $ from "jquery";
import SeFacilityMap from "@golocalinteractive/se-facility-map";
import "../lightgallery/js/lightgallery.min.js";
import "bootstrap-select/js/bootstrap-select";

$(document).ready(function () {
  const facilityMapSelector = "#theMap";
  const mapTabSelector = "#map-directions-tab";

  if ($(facilityMapSelector).length && google !== undefined) {
    var colors = {
      primary:
        typeof map_pin_color !== "undefined"
          ? map_pin_color
          : $($(".btn-primary")[0]).css("background-color")
    };

    var facilityMap = new SeFacilityMap({
      el: facilityMapSelector,
      marker: {
        labels: {},
        icon: {
          path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z",
          strokeColor: colors.primary,
          fillColor: colors.primary,
          fillOpacity: 1.0,
          scale: 32 / 512,
          size: new google.maps.Size(32, 32),
          anchor: new google.maps.Point(256, 512)
        }
      },
      map: {
        minZoom: 10,
        gestureHandling: "cooperative"
      },
      locationClass: "facility-map-info",
      onCreated: function (map) {
        const facilityMapInstance = this;
        function CenterControl(controlDiv, map) {
          // Hide control if there aren't any nearby facilities
          if ($(".facility-map-info").length > 1) {
            let controlUI = document.createElement("div");
            controlUI.style.backgroundColor = "#fff";
            controlUI.style.border = "2px solid #fff";
            controlUI.style.borderRadius = "3px";
            controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
            controlUI.style.cursor = "pointer";
            controlUI.style.marginTop = "10px";
            controlUI.style.marginLeft = "10px";
            controlUI.style.textAlign = "center";
            controlUI.title = "View Nearby Locations";
            controlDiv.appendChild(controlUI);

            let controlText = document.createElement("div");
            controlText.style.color = "rgb(25,25,25)";
            controlText.style.fontFamily = "omnes-pro,Arial,sans-serif";
            controlText.style.fontSize = "15px";
            controlText.style.fontWeight = "500";
            controlText.style.lineHeight = "38px";
            controlText.style.paddingLeft = "15px";
            controlText.style.paddingRight = "15px";
            controlText.innerHTML =
              '<span class="fas fa-location mr-2"></span> View Nearby Locations';
            controlUI.appendChild(controlText);
            // Setup the click event listeners: hides the map off viewport
            controlUI.addEventListener("click", function (e) {
              e.preventDefault();
              loadNearbyLocations();
            });
          }
        }

        let centerControlDiv = document.createElement("div");
        let centerControl = new CenterControl(centerControlDiv, map);
        centerControlDiv.index = 1;
        map.controls[google.maps.ControlPosition.LEFT_TOP].push(
          centerControlDiv
        );

        if (
          facilityMapInstance.markers &&
          facilityMapInstance.markers.length > 0
        ) {
          const marker = facilityMapInstance.markers[0];

          if (!marker.infowindow) {
            marker.infowindow = new google.maps.InfoWindow({
              content: $(".facility-map-info").first().html()
            });
          }

          // Open the info window and center the map on the marker
          marker.infowindow.open({
            map: facilityMapInstance.map,
            anchor: marker
          });

          facilityMapInstance.map.setCenter(marker.getPosition());
          facilityMapInstance.map.panBy(0, -100); // Adjust pan offset if needed
        }
      }
    });

    $(mapTabSelector).on("click", function () {
      facilityMap.openMarker(0);
      facilityMap.map.panBy(0, -100);

      var markers = [...facilityMap.markers]; // spread so we don't alter reference to facilityMap.markers
      markers.shift();
      markers.forEach(function (marker) {
        marker.setVisible(false);
      });
    });
  }

  function loadNearbyLocations() {
    var bounds = new google.maps.LatLngBounds();
    facilityMap.markers.forEach(function (marker) {
      marker.setVisible(true);
      bounds.extend(marker.getPosition());
    });
    facilityMap.map.fitBounds(bounds);
  }

  // Animate the body to someplace when a certain link or button is clicked
  function scrollToElement(position) {
    $("body, html").animate({ scrollTop: position });
  }

  // scroll to the reviews
  $(".reviews-trigger").on("click", function (e) {
    e.preventDefault();
    if ($(window).width() > 992) {
      var pos = $(".fac-reviews").offset().top - $(".header-nav").height();
      scrollToElement(pos);
    } else {
      var pos = $(".fac-reviews").offset().top;
      scrollToElement(pos);
    }
  });

  // scroll to the units
  $(".view-units-trigger").on("click", function (e) {
    e.preventDefault();
    console.log("btn clicked");
    if ($(window).width() > 992) {
      var pos = $(".facility-content").offset().top - $(".header-nav").height();
      scrollToElement(pos);
      //$(".units-tab").tab("show");
      $("[href='#units']").tab("show");
    } else {
      var pos = $(".available-units-tab").offset().top;
      scrollToElement(pos);
      // $(".units-tab").tab("show");
      $("[href='#units']").tab("show");
    }
  });

  // scroll to the map
  function scrollToElement(position) {
    $("body, html").animate({ scrollTop: position });
  }
  $(".locations-trigger").on("click", function (e) {
    e.preventDefault();

    // Get coordinates directly from the button's data attributes
    const facilityLat = parseFloat($(this).data('facility-lat'));
    const facilityLng = parseFloat($(this).data('facility-lng'));

    // Find the marker index that matches these coordinates
    let markerIndex = -1;
    if (facilityMap && facilityMap.markers) {
      markerIndex = facilityMap.markers.findIndex(marker => {
        const markerPos = marker.getPosition();
        return Math.abs(markerPos.lat() - facilityLat) < 0.0001 &&
          Math.abs(markerPos.lng() - facilityLng) < 0.0001;
      });
    }

    const oldTemplate = $(".facility-content");
    const mapTab = $(".map-directions-tab");
    if ($(window).width() > 992) {
      if (oldTemplate.length > 0) {
        var pos =
          $(".facility-content").offset().top -
          $(".header-nav").height() -
          $(".wp-block-spacer").height();
        scrollToElement(pos);
        mapTab.tab("show");
      } else {
        const mapItem = $('#map-tab');
        const pos =
          mapItem.offset().top -
          $('.rain-facility-tabs').height() -
          $(".header-nav").height();
        scrollToElement(pos);
        mapItem.tab("show");
      }
    } else {
      if (oldTemplate.length > 0) {
        var pos = mapTab.offset().top;
        scrollToElement(pos);
        mapTab.tab("show");
      } else {
        const mapItem = $('#map-tab');
        const pos = mapItem.offset().top;
        scrollToElement(pos);
        mapItem.tab("show");
      }
    }

    // After scrolling and showing the tab, open the specific marker
    setTimeout(() => {
      if (markerIndex >= 0 && facilityMap) {
        facilityMap.openMarker(markerIndex);
        facilityMap.map.panBy(0, -100);

        // Make sure this marker is visible if it was hidden
        facilityMap.markers[markerIndex].setVisible(true);
      }
    }, 500); // Wait for tab animation to complete
  });

  // Annex location trigger - handles cards with potentially duplicate coordinates
  $(".annex-location-trigger").on("click", function (e) {
    e.preventDefault();

    // Get coordinates directly from the button's data attributes
    const facilityLat = parseFloat($(this).data('facility-lat'));
    const facilityLng = parseFloat($(this).data('facility-lng'));

    // Find ALL markers that match these coordinates
    let markerIndex = -1;
    if (facilityMap && facilityMap.markers) {
      const matchingIndices = [];
      facilityMap.markers.forEach((marker, index) => {
        const markerPos = marker.getPosition();
        if (Math.abs(markerPos.lat() - facilityLat) < 0.0001 &&
          Math.abs(markerPos.lng() - facilityLng) < 0.0001) {
          matchingIndices.push(index);
        }
      });

      // If there are 2+ matches, use the second one; otherwise use the first
      if (matchingIndices.length >= 2) {
        markerIndex = matchingIndices[1]; // Second match (annex)
      } else if (matchingIndices.length === 1) {
        markerIndex = matchingIndices[0]; // First match
      }
      // If no matches, markerIndex stays -1
    }

    const oldTemplate = $(".facility-content");
    const mapTab = $(".map-directions-tab");
    if ($(window).width() > 992) {
      if (oldTemplate.length > 0) {
        var pos =
          $(".facility-content").offset().top -
          $(".header-nav").height() -
          $(".wp-block-spacer").height();
        scrollToElement(pos);
        mapTab.tab("show");
      } else {
        const mapItem = $('#map-tab');
        const pos =
          mapItem.offset().top -
          $('.rain-facility-tabs').height() -
          $(".header-nav").height();
        scrollToElement(pos);
        mapItem.tab("show");
      }
    } else {
      if (oldTemplate.length > 0) {
        var pos = mapTab.offset().top;
        scrollToElement(pos);
        mapTab.tab("show");
      } else {
        const mapItem = $('#map-tab');
        const pos = mapItem.offset().top;
        scrollToElement(pos);
        mapItem.tab("show");
      }
    }

    // After scrolling and showing the tab, open the specific marker
    setTimeout(() => {
      if (markerIndex >= 0 && facilityMap) {
        facilityMap.openMarker(markerIndex);
        facilityMap.map.panBy(0, -100);

        // Make sure this marker is visible if it was hidden
        facilityMap.markers[markerIndex].setVisible(true);
      }
    }, 500); // Wait for tab animation to complete
  });

  $(".btn-toggle-filters-mobile").on("click", function (e) {
    $(".unit-size-filters").toggle();
  });

  // lightgallery init
  var lg = lightGallery(document.getElementById("facility-gallery"));

  $(".slider-gallery-trigger").on("click", function (e) {
    var elements = $(".carousel-item");
    var settings = {
      dynamic: true,
      dynamicEl: elements.map((i, el) => {
        return {
          src: $(el).data("src")
        };
      })
    };

    lightGallery(document.getElementById("dynamic-facility-gallery"), settings);
  });

  /**
   * Simple Unit Size Filters
   */
  var filters = {
    size: {
      filterType: "OR",
      filters: []
    }
  };

  $(".size-filter").click(function (e) {
    var data = $(this).data("size");
    if (data.includes(",")) {
      filters.size.filters = data.split(",");
    } else {
      filters.size.filters = [];
      filters.size.filters.push($(this).data("size"));
    }

    $(".size-filter").removeClass("active");
    $(this).addClass("active");

    $(".units-table").fadeOut(300, function () {
      $(".unit-item").seFilterItems(filters, true);
      $(".units-table").fadeIn(300);
    });
  });

  /**
   * Filtering by unit feature and size.
   * Only include these functions if we are filtering
   * by features in addition to unit sizes.
   */
  if ($(".secur-size-filter")) {
    var filters = {
      features: {
        filterType: "AND",
        filters: []
      },
      size: {
        filterType: "OR",
        filters: []
      }
    };

    $(".secur-size-filter").on("click", function (e) {
      var data = $(this).data("size");
      setActiveSizeFilter(data);

      if (data.includes(",")) {
        filters.size.filters = data.split(",");
      } else {
        filters.size.filters = [];
        filters.size.filters.push($(this).data("size"));
      }

      $(".secur-size-filter").removeClass("active");
      $(this).addClass("active");

      filterUnits();
    });

    // Feature filtering - takes into account both size/feature filters
    $(".secur-selectpicker").on("change", function (e) {
      var filterValue = $(this).val();
      if ($(this).attr("name") === "size") setActiveSizeFilter(filterValue);

      if (filterValue.includes(",")) {
        filterValue = filterValue.split(",");
      }
      filters[$(this).attr("name")].filters = filterValue;

      filterUnits();
    });

    // Show/hide unit rows based on filters
    function filterUnits() {
      $(".units-table").fadeOut(300, function () {
        $(".unit-item").seFilterItems(filters, true);
        $(".units-table").fadeIn(300);

        // below - would use :visible but the fadeIn() above give us false positives since they're not visible for 300ms
        if ($('.unit-item:not([style*="display: none"])').length === 0) {
          $("#filter-zero-results").show();
        } else {
          $("#filter-zero-results").hide();
        }
      });
    }

    // Ensure dropdown and size filter buttons are in sync if changing window sizes.
    function setActiveSizeFilter(value) {
      $(".secur-size-filter").removeClass("active");
      $('.secur-size-filter[data-size="' + value + '"]').addClass("active");
      $('.secur-selectpicker[name="size"]').selectpicker("val", value);
    }
  }

  /**
   * Load More Reviews functionality
   */
  $("#load_more_reviews").click(function (e) {
    let num_to_load = $(".fac-reviews").attr("data-reviews-per");
    $(".customer-review.d-none").each((index, elem) => {
      if (index < num_to_load) $(elem).removeClass("d-none");
    });
    if ($(".customer-review.d-none").length === 0)
      $("#load_more_reviews").hide();
  });

  var vbp_prefix = "value-based-btn-hdr-promo-";

  $(".btn-rent-reserve, .vbp__btn").on("click", function (e) {
    $('.modal-rent [name="fid"], .modal-reserve [name="facility_id"]').val(
      $(this).data("fid")
    );
    $('.modal-rent [name="uid"]').val($(this).data("uid"));
    $('.modal-reserve [name="_se_unit_id"]').val($(this).data("seid"));

    $(".se-reserve-button, .se-rent-button").removeClass(
      vbp_prefix + "a " + vbp_prefix + "b " + vbp_prefix + "c"
    );
  });

  /* avoid accordion functionality on desktop and instead open rent/reserve splash modal */
  $(".vbp__btn-vertical, [class*=value-based-btn-hdr-promo-]").on(
    "click",
    function (e) {
      if (window.innerWidth > 991) {
        e.stopPropagation();

        $("[id^=valuePricingModal]").modal("hide");
        $("#splashModal").modal("show");
      }
      var vbpClass = $(this)
        .prop("class")
        .split(" ")
        .filter((c) => c.match(/^value-based-btn-hdr-promo-/g));
      $(".se-reserve-button, .se-rent-button")
        .removeClass(vbp_prefix + "a " + vbp_prefix + "b " + vbp_prefix + "c")
        .addClass(vbpClass);
    }
  );

  let open_close_office_txt = $(
    "#HoursTabContent > #office-hours > .hours-list > li"
  ).first();
  let open_close_access_txt = $(
    "#HoursTabContent > #access-hours > .hours-list > li"
  ).first();

  // If Open/Close status is enabled
  if (
    open_close_office_txt.hasClass("title") ||
    open_close_access_txt.hasClass("title")
  ) {
    // Check Timezone
    let $time_zone = $("#timezone").data("timezone");

    let localOptions = {
      timeZone: $time_zone,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    },
      $timezone_time = new Date().toLocaleString([], localOptions);

    var d = new Date($timezone_time);
    var $timezone_hours = d.getHours();
    var $timezone_minutes = d.getMinutes();

    const convertTime12to24 = (time12h) => {
      const [time, modifier] = time12h.split(" ");

      let [hours, minutes] = time.split(":");

      if (hours === "12") {
        hours = "00";
      }

      if (modifier === "pm") {
        hours = parseInt(hours, 10) + 12;
      }

      return `${hours}:${minutes}`;
    };

    function start_end_time(
      start_time,
      end_time,
      close_time,
      close_am_pm,
      hours_type
    ) {
      var dt = new Date($timezone_time);

      //convert both times into timestamp
      var stt = new Date(
        dt.getMonth() +
        1 +
        "/" +
        dt.getDate() +
        "/" +
        dt.getFullYear() +
        " " +
        start_time
      );
      stt = stt.getTime();

      var endt = new Date(
        dt.getMonth() +
        1 +
        "/" +
        dt.getDate() +
        "/" +
        dt.getFullYear() +
        " " +
        end_time
      );
      endt = endt.getTime();

      var time = dt.getTime();

      if (time > stt && time < endt) {
        $(`#${hours_type}-hours > .hours-list > .title`).text(
          `Open today until ${close_time}${close_am_pm}`
        );
      } else {
        $(`#${hours_type}-hours > .hours-list > .title`).text(
          "Currently Closed"
        );
      }
    }

    // Update Office Hours
    $("#office-hours .hours-list li").each(function () {
      var hours_type = "office";
      var $time_span = $(this).find("span");
      $time_span.addClass("timeframe");
      var $time_txt = $(this).find(".timeframe").text();

      if ($time_txt != "" && $(this).hasClass("selected")) {
        // If time is not set
        if ($time_txt === "Closed") {
          $("#office-hours > .hours-list > .title").text("Currently Closed");
          return false;
        }
        if ($time_txt === "24 Hours") {
          $("#office-hours > .hours-list > .title").text("Open all day");
          return false;
        }
        if ($time_txt === "By Appointment Only") {
          $("#office-hours > .hours-list > .title").text("Currently Closed");
          return false;
        }

        var $split = $time_txt.split("-");
        var $open_time = $split[0].replace(/ /g, "").slice(0, -2);
        var $close_time = $split[1].replace(/ /g, "").slice(0, -2);
        var $open_am_pm = $split[0].replace(/ /g, "").slice(-2);
        var $close_am_pm = $split[1].replace(/ /g, "").slice(-2);
        var $open_time_final = convertTime12to24(
          `${$open_time} ${$open_am_pm}`
        );
        var $close_time_final = convertTime12to24(
          `${$close_time} ${$close_am_pm}`
        );

        var startTime = $open_time_final + ":00";
        var endTime = $close_time_final + ":00";

        start_end_time(
          startTime,
          endTime,
          $close_time,
          $close_am_pm,
          hours_type
        );
      }
    });

    $("#access-hours .hours-list li").each(function () {
      var hours_type = "access";
      var $time_span = $(this).find("span");
      $time_span.addClass("timeframe");
      var $time_txt = $(this).find(".timeframe").text();

      if ($time_txt != "" && $(this).hasClass("selected")) {
        // If time is not set
        if ($time_txt === "Closed") {
          $("#access-hours > .hours-list > .title").text("Currently Closed");
          return false;
        }
        if ($time_txt === "24 Hours") {
          $("#access-hours > .hours-list > .title").text("Open all day");
          return false;
        }
        if ($time_txt === "By Appointment Only") {
          $("#access-hours > .hours-list > .title").text("Currently Closed");
          return false;
        }

        var $split = $time_txt.split("-");
        var $open_time = $split[0].replace(/ /g, "").slice(0, -2);
        var $close_time = $split[1].replace(/ /g, "").slice(0, -2);
        var $open_am_pm = $split[0].replace(/ /g, "").slice(-2);
        var $close_am_pm = $split[1].replace(/ /g, "").slice(-2);
        var $open_time_final = convertTime12to24(
          `${$open_time} ${$open_am_pm}`
        );
        var $close_time_final = convertTime12to24(
          `${$close_time} ${$close_am_pm}`
        );

        var startTime = $open_time_final + ":00";
        var endTime = $close_time_final + ":00";

        start_end_time(
          startTime,
          endTime,
          $close_time,
          $close_am_pm,
          hours_type
        );
      }
    });
  }

  $(".nearby-unit-title").on("click", function () {
    $(this).siblings(".nearby-unit-list").toggleClass("d-none");
  });

  $(function () {
    isElementExist(".carousel", initCarousel);
    isElementExist(".review-slider", initReviewSlider);
    setTimeout(() => {
      isElementExist("#modalText", readMore);
    }, 1000);
  });

  // Helper if element exist then call function
  function isElementExist(_el, _cb) {
    const elem = document.querySelector(_el);

    if (document.body.contains(elem)) {
      try {
        _cb();
      } catch (e) {
        console.log(e);
      }
    }
  }


  function initCarousel() {
    let carousels = document.querySelectorAll(".carousel");

    carousels.forEach(function (slider) {
      const carouselInner = slider.querySelector(".carousel-slider");
      const buttonNext = slider.querySelector(".swiper-button-next");
      const buttonPrev = slider.querySelector(".swiper-button-prev");

      const carousel = new Swiper(carouselInner, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        watchSlidesProgress: true,
        autoHeight: true,
        simulateTouch: false,

        navigation: {
          nextEl: buttonNext,
          prevEl: buttonPrev,
        },

        on: {
          slideChange: function (el) {
            const youTubeVideo = slider.querySelectorAll("iframe");

            if (youTubeVideo) {
              youTubeVideo.forEach(function (video) {
                video.src = video.src;
              });
            }
          },
        },
      });
    });
  }

  function initReviewSlider() {
    const reviewSliders = document.querySelectorAll(".review-slider");

    reviewSliders.forEach(function (slider) {
      const v2 = slider.classList.contains("_v2");
      const buttonNext = slider.querySelector(".swiper-button-next");
      const buttonPrev = slider.querySelector(".swiper-button-prev");

      const reviewSlider = new Swiper(slider, {
        slidesPerView: v2 ? 2 : 4,
        spaceBetween: v2 ? 60 : 35,
        loop: true,
        watchSlidesProgress: true,

        navigation: {
          nextEl: buttonNext,
          prevEl: buttonPrev,
        },

        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: v2 ? 1 : 2,
            spaceBetween: 25,
          },
          768: {
            slidesPerView: v2 ? 2 : 2,
            spaceBetween: 25,
          },
          960: {
            slidesPerView: v2 ? 2 : 3,
            spaceBetween: v2 ? 40 : 30,
          },
          1260: {
            slidesPerView: v2 ? 2 : 4,
            spaceBetween: v2 ? 60 : 35,
          },
        },
      });
    });
  }

  function readMore() {
    const readMoreButtons = document.querySelectorAll('.review-read-more');
    const modal = document.getElementById('reviewModal');
    const modalText = modal.querySelector('#modalText');
    const modalAuthor = modal.querySelector('#modalAuthor');
    const modalStars = modal.querySelector('#modalStars');
    const closeModal = modal.querySelector('.close');

    readMoreButtons.forEach(button => {
      button.addEventListener('click', function () {
        modalText.textContent = this.getAttribute('data-review');
        modalAuthor.textContent = this.getAttribute('data-author');
        const widthPercentage = (this.getAttribute('data-stars') / 5) * 100;
        modalStars.style.width = `calc(${widthPercentage}%)`;
        modal.style.display = 'block';
      });
    });

    closeModal.addEventListener('click', function () {
      modal.style.display = 'none';
    });

    window.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    })
  }
});
